import * as actionTypes from './actionTypes';

export const authStart = () => {
    console.log('[actions] authStart');
    return {
        type: actionTypes.AUTH_START,
    };
}

export const authSuccess = ( token, userId ) => {
    console.log('[actions] authSuccess');
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        userId: userId
    };
}

export const authFail = (error) => {
    console.log('[actions] authFail');
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
}

export const auth = ( email, password, isSignup ) => {
    console.log('[actions] auth');
    return {
        type: actionTypes.AUTH_USER,
        email: email,
        password: password,
        isSignup: isSignup
    }
};

//using redux-saga
export const logout = () => {
    console.log('[action auth] logout');
    return {
        type: actionTypes.AUTH_INITIATE_LOGOUT
    };
};

export const logoutSucceed = () => {
    console.log('[action auth] logoutSucceed');
    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const checkAuthTimeout = (expirationTime) => {
    console.log('[action auth] checkAuthTimeout', expirationTime);
    return {
        type: actionTypes.AUTH_CHECK_TIMEOUT,
        expirationTime: expirationTime
    }
}

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

export const authCheckState = () => {
    console.log('[auth action]', actionTypes.AUTH_CHECK_STATE );
    return {
        type: actionTypes.AUTH_CHECK_STATE
    }
}